import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ACTION_COMMANDS_MODAL_TYPE, ACTION_COMMANDS_TYPE } from '../../../../api/ActionCommandsInterface/constants';
import { ApiTrackingWhitelistEndpoints, Endpoints, RestartSessionBlacklistEndpoints } from '../../../../api/Constants';
import { EVENTS_GAMEPLAY_STATE_NOT_FOUND_ERROR, MISSIONS_GAMEPLAY_STATE_NOT_FOUND_ERROR, PLATFORM } from '../../../../constants';
import { EVENT_TYPES } from '../../../../lib/analytics/constants';
import Logger from '../../../../lib/analytics/logger';
import screens from '../../../../screens';
import useNotificationsPermissions from '../../../../screens/DynamicPopups/hooks/useNotificationsPermissions';
import utils from '../../../../utils';
import ENVIRONMENT_VARIABLES from '../../../../utils/environmentVariables';
import ERROR_CODE from '../../../../utils/errorCodes';
import { getObjectValues, hasObjectValues } from '../../../../utils/object';
import store from '../../../store';

var restartSessionState = function restartSessionState() {
  return store.getState().app.restartSession;
};

export var validApiTracking = function validApiTracking(url) {
  return ENVIRONMENT_VARIABLES.ENABLE_API_TRACKING === 'true' && ApiTrackingWhitelistEndpoints.includes(url);
};
export var validDiveErrorHandling = function validDiveErrorHandling() {
  return ENVIRONMENT_VARIABLES.DIVE_ERROR_HANDLING === 'yes';
};
export var validRestartSession = function validRestartSession(_ref) {
  var url = _ref.config.url;
  return !restartSessionState() && RestartSessionBlacklistEndpoints.indexOf(url) < 0;
};
export var restartSessionActive = function restartSessionActive(_ref2) {
  var url = _ref2.url;
  return restartSessionState() && url !== Endpoints.RESTART_SESSION;
};
export var skipEventError = function skipEventError(errorType) {
  return errorType === MISSIONS_GAMEPLAY_STATE_NOT_FOUND_ERROR || errorType === EVENTS_GAMEPLAY_STATE_NOT_FOUND_ERROR;
};

var postTriggersNotify = function postTriggersNotify(executionId) {
  var _require = require('../../../query/actionCommands'),
      postTriggersNotify = _require.postTriggersNotify;

  store.dispatch(postTriggersNotify.initiate({
    executionId: executionId
  }));
};

var deleteTriggerNotify = function deleteTriggerNotify(executionId) {
  var _require2 = require('../../../query/actionCommands'),
      deleteTriggerNotify = _require2.deleteTriggerNotify;

  store.dispatch(deleteTriggerNotify.initiate({
    executionId: executionId
  }));
};

var getAssetsPackage = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(assetsPackageId) {
    var _require3, getAssetsPackage, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _require3 = require('../../../query/assetsPackage'), getAssetsPackage = _require3.getAssetsPackage;
            _context.prev = 1;
            _context.next = 4;
            return store.dispatch(getAssetsPackage.initiate({
              assetsPackageId: assetsPackageId
            })).unwrap();

          case 4:
            response = _context.sent;

            if (!(response !== null && response !== void 0 && response.assetsPackage)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", true);

          case 7:
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", false);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function getAssetsPackage(_x) {
    return _ref3.apply(this, arguments);
  };
}();

export var validateActionCommand = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(actions) {
    var actionsValidated, existingActions, i, _ret, j, _actionsValidated$j$m, modalType, assetsPackageId, assetsLoaded;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            actionsValidated = [];
            existingActions = store.getState().actionCommands.actions;
            i = 0;

          case 3:
            if (!(i < actions.length)) {
              _context3.next = 17;
              break;
            }

            _context3.prev = 4;
            return _context3.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var _store$getState$actio, _actions$i$gameTutori, _actions$i$eventsTuto, _actions$i$eventsTuto2;

              var _actions$i, actionType, uuid, _actions$i$modal, modal, _useNotificationsPerm, checkIfPermissionsRequestable, requestNativePermissions;

              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _actions$i = actions[i], actionType = _actions$i.actionType, uuid = _actions$i.uuid, _actions$i$modal = _actions$i.modal, modal = _actions$i$modal === void 0 ? null : _actions$i$modal;

                      if (!existingActions.some(function (action) {
                        return action.uuid === uuid;
                      })) {
                        _context2.next = 3;
                        break;
                      }

                      return _context2.abrupt("return", "continue");

                    case 3:
                      _context2.t0 = actionType;
                      _context2.next = _context2.t0 === ACTION_COMMANDS_TYPE.DISPLAY_MODAL ? 6 : _context2.t0 === ACTION_COMMANDS_TYPE.DISPLAY_MISSIONS_TUTORIAL ? 37 : _context2.t0 === ACTION_COMMANDS_TYPE.DISPLAY_GAME_TUTORIAL ? 39 : _context2.t0 === ACTION_COMMANDS_TYPE.DISPLAY_TOOLTIP ? 41 : _context2.t0 === ACTION_COMMANDS_TYPE.DISPLAY_EVENTS_TUTORIAL ? 43 : _context2.t0 === ACTION_COMMANDS_TYPE.NOTIFICATION ? 45 : 47;
                      break;

                    case 6:
                      _context2.t1 = modal.modalType;
                      _context2.next = _context2.t1 === ACTION_COMMANDS_MODAL_TYPE.ALLOW_NOTIFICATIONS ? 9 : _context2.t1 === ACTION_COMMANDS_MODAL_TYPE.DAILY_WHEEL ? 32 : 34;
                      break;

                    case 9:
                      if (!(utils.getPlatform() !== PLATFORM.WEB)) {
                        _context2.next = 30;
                        break;
                      }

                      _useNotificationsPerm = useNotificationsPermissions(), checkIfPermissionsRequestable = _useNotificationsPerm.checkIfPermissionsRequestable, requestNativePermissions = _useNotificationsPerm.requestNativePermissions;

                      if (!modal.nativeDialog) {
                        _context2.next = 21;
                        break;
                      }

                      _context2.next = 14;
                      return requestNativePermissions(modal.modalType, modal.onDisplayAction);

                    case 14:
                      if (!_context2.sent) {
                        _context2.next = 18;
                        break;
                      }

                      postTriggersNotify(modal.onDisplayAction.triggerExecution.executionId);
                      _context2.next = 19;
                      break;

                    case 18:
                      deleteTriggerNotify(modal.onDismissAction.triggerExecution.executionId);

                    case 19:
                      _context2.next = 28;
                      break;

                    case 21:
                      _context2.next = 23;
                      return checkIfPermissionsRequestable();

                    case 23:
                      if (!_context2.sent) {
                        _context2.next = 27;
                        break;
                      }

                      actionsValidated.push(actions[i]);
                      _context2.next = 28;
                      break;

                    case 27:
                      deleteTriggerNotify(modal.onDismissAction.triggerExecution.executionId);

                    case 28:
                      _context2.next = 31;
                      break;

                    case 30:
                      deleteTriggerNotify(modal.onDismissAction.triggerExecution.executionId);

                    case 31:
                      return _context2.abrupt("break", 36);

                    case 32:
                      if (utils.quickObjectComparision(store.getState().actionCommands.lastActionExecuted, actions[i]) === false) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 36);

                    case 34:
                      if (getObjectValues(ACTION_COMMANDS_MODAL_TYPE).find(function (val) {
                        return val === modal.modalType;
                      }) !== undefined) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 36);

                    case 36:
                      return _context2.abrupt("break", 48);

                    case 37:
                      if (!((_store$getState$actio = store.getState().actionCommands.actions[0]) !== null && _store$getState$actio !== void 0 && _store$getState$actio.missionsTutorial) && hasObjectValues(store.getState().missions.data)) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 48);

                    case 39:
                      if ((_actions$i$gameTutori = actions[i].gameTutorial) !== null && _actions$i$gameTutori !== void 0 && _actions$i$gameTutori.gameId && utils.quickObjectComparision(store.getState().actionCommands.lastActionExecuted, actions[i]) === false) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 48);

                    case 41:
                      if (utils.quickObjectComparision(store.getState().actionCommands.lastActionExecuted, actions[i]) === false) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 48);

                    case 43:
                      if ((_actions$i$eventsTuto = actions[i].eventsTutorial) !== null && _actions$i$eventsTuto !== void 0 && _actions$i$eventsTuto.onCompleteAction && (_actions$i$eventsTuto2 = actions[i].eventsTutorial) !== null && _actions$i$eventsTuto2 !== void 0 && _actions$i$eventsTuto2.onSkipAction) {
                        actionsValidated.push(actions[i]);
                      }

                      return _context2.abrupt("break", 48);

                    case 45:
                      actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 48);

                    case 47:
                      return _context2.abrupt("break", 48);

                    case 48:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })(), "t0", 6);

          case 6:
            _ret = _context3.t0;

            if (!(_ret === "continue")) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt("continue", 14);

          case 9:
            _context3.next = 14;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t1 = _context3["catch"](4);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context3.t1, Object.getOwnPropertyNames(_context3.t1)),
              body: JSON.stringify(actions[i]),
              code: ERROR_CODE.ACTIONS_COMANDS_VALIDATION_ERROR
            });

          case 14:
            i++;
            _context3.next = 3;
            break;

          case 17:
            j = 0;

          case 18:
            if (!(j < actionsValidated.length)) {
              _context3.next = 36;
              break;
            }

            _context3.prev = 19;

            if (!(actionsValidated[j].modal && actionsValidated[j].modal.assetsPackageId)) {
              _context3.next = 28;
              break;
            }

            _actionsValidated$j$m = actionsValidated[j].modal, modalType = _actionsValidated$j$m.modalType, assetsPackageId = _actionsValidated$j$m.assetsPackageId;

            if (!(modalType === ACTION_COMMANDS_MODAL_TYPE.DAILY_WHEEL || modalType === ACTION_COMMANDS_MODAL_TYPE.DAILY_WHEEL_ONBOARDING)) {
              _context3.next = 24;
              break;
            }

            return _context3.abrupt("continue", 33);

          case 24:
            _context3.next = 26;
            return getAssetsPackage(assetsPackageId);

          case 26:
            assetsLoaded = _context3.sent;
            if (!assetsLoaded) actionsValidated.splice(j, 1);

          case 28:
            _context3.next = 33;
            break;

          case 30:
            _context3.prev = 30;
            _context3.t2 = _context3["catch"](19);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context3.t2, Object.getOwnPropertyNames(_context3.t2)),
              code: ERROR_CODE.ACTIONS_COMANDS_ASSETS_ERROR
            });

          case 33:
            j++;
            _context3.next = 18;
            break;

          case 36:
            return _context3.abrupt("return", actionsValidated.map(function (action) {
              var _action$payload;

              return !(action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.screen) ? _objectSpread(_objectSpread({}, action), {}, {
                payload: _objectSpread(_objectSpread({}, action.payload), {}, {
                  screen: screens.Home
                })
              }) : action;
            }));

          case 37:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 11], [19, 30]]);
  }));

  return function validateActionCommand(_x2) {
    return _ref4.apply(this, arguments);
  };
}();